import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';

import { AdmissionProfileComponent } from '../components/ehr/admission/admission-profile/admission-profile.component';
import { AdmissionPersonalInfoComponent } from '../components/ehr/admission/admission-profile/admission-personal-info/admission-personal-info.component';
import { AdmissionMedicalInfoComponent } from '../components/ehr/admission/admission-profile/admission-medical-info/admission-medical-info.component';
import { AdmissionAddressInfoComponent } from '../components/ehr/admission/admission-profile/admission-address-info/admission-address-info.component';
import { AdmissionEmergencyContactsInfoComponent } from '../components/ehr/admission/admission-profile/admission-emergency-contacts-info/admission-emergency-contacts-info.component';
import { AdmissionTimelineComponent } from '../components/ehr/admission/admission-profile/admission-timeline/admission-timeline.component';
import { AdmissionComponent } from '../components/ehr/admission/admission.component';
import { AdmissionDocumentsComponent } from '../components/ehr/admission/admission-profile/admission-documents/admission-documents.component';
import { AdmissionRejectModalComponent } from '../components/ehr/admission/admission-reject-modal/admission-reject-modal.component';
import { AdmissionAdmitModalComponent } from '../components/ehr/admission/admission-admit-modal/admission-admit-modal.component';
import { AdmissionPopupComponent } from '../components/ehr/admission/admission-popup/admission-popup.component';
import { AdmissionInsuranceComponent } from '../components/ehr/admission/admission-profile/admission-insurance/admission-insurance.component';
import { AdmissionTimelineHistoryComponent } from '../components/ehr/admission/admission-profile/admission-timeline-history/admission-timeline-history.component';
import { ExternalDoctorsComponent } from '../components/ehr/admission/admission-profile/admission-medical-info/external-doctors/external-doctors.component';
import { DocumentComponent } from '../components/ehr/admission/admission-profile/admission-documents/document/document.component';

@NgModule({
  declarations: [
    AdmissionProfileComponent,
    AdmissionPersonalInfoComponent,
    AdmissionMedicalInfoComponent,
    AdmissionAddressInfoComponent,
    AdmissionEmergencyContactsInfoComponent,
    AdmissionTimelineComponent,
    AdmissionComponent,
    AdmissionDocumentsComponent,
    AdmissionRejectModalComponent,
    AdmissionAdmitModalComponent,
    AdmissionPopupComponent,
    AdmissionInsuranceComponent,
    AdmissionTimelineHistoryComponent,
    ExternalDoctorsComponent,
    DocumentComponent,
  ],
  imports: [SharedModule],
  exports: [
    AdmissionProfileComponent,
    AdmissionPersonalInfoComponent,
    AdmissionMedicalInfoComponent,
    AdmissionAddressInfoComponent,
    AdmissionEmergencyContactsInfoComponent,
    AdmissionTimelineComponent,
    AdmissionComponent,
    AdmissionDocumentsComponent,
    AdmissionRejectModalComponent,
    AdmissionAdmitModalComponent,
    AdmissionPopupComponent,
    AdmissionInsuranceComponent,
    AdmissionTimelineHistoryComponent,
    ExternalDoctorsComponent,
    DocumentComponent,
  ],
})
export class AdmissionsModule {}
